// src/components/Services.jsx
import React, { useEffect } from "react";
import "../styles/services.css";
import "../styles/common.css";
import AOS from "aos";
import "aos/dist/aos.css";

const services = [
  {
    title: "Olajcsere Szolnokon",
    image: "/images/oilchange_service.webp",
    description:
      "A rendszeres olajcsere elengedhetetlen a motor élettartamához – de használt autó vásárlása után különösen fontos, hogy friss olaj kerüljön a rendszerbe. Mi gyári minőségű kenőanyagokkal és szűrőkkel dolgozunk, és a teljes olajcserét rövid határidővel vállaljuk.",
  },
  {
    title: "Fékcsere és fékjavítás Szolnokon",
    image: "/images/brake_service.webp",
    description:
      "A fékberendezés állapota az egyik legfontosabb biztonsági tényező az autóban – semmiképp sem érdemes halogatni az ellenőrzését. Autószervizünkben vállaljuk a fékbetétek, féktárcsák, fékfolyadékok cseréjét és ellenőrzését Szolnokon, szakszerűen, rövid határidővel..",
  },
  {
    title: "Állapotfelmérés autóra – különösen vásárlás előtt",
    image: "/images/inspection_service.webp",
    description:
      "Használt autót vásároltál? Vagy most készülsz rá? Egy részletes műszaki állapotfelmérés segít kiszűrni a rejtett hibákat, mielőtt komoly kiadásokba futnál. Fékek, futómű, folyadékszintek, elektronika – mindent ellenőrzünk, amit kell. Nem vagy biztos benne, hogy minden rendben van? Mi átvizsgáljuk, megjavítjuk vagy kicseréljük, amit kell – hogy mindig biztonságosan meg tudj állni.",
  },
];

const Services = () => {
  useEffect(() => {
    AOS.init({
      duration: 700,
      once: true,
      offset: 80,
      easing: "ease-out",
    });
  }, []);

  return (
    <section className="services-section pt-5" id="services">
      <div className="container">
        <h2 className="h2-header text-center">
          Szolgáltatásaink – hogy autója Szolnok útjain mindig megbízható legyen
        </h2>
        <div className="divider">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <p className="services-intro text-center mb-5">
          Szolnoki autószervizként arra specializálódtunk, hogy a legfontosabb
          karbantartási feladatokat gyorsan, pontosan és jó áron végezzük el. Fő
          profilunk az olajcsere, a fékcsere és a műszaki állapotfelmérés – mert
          ezek biztosítják a jármű hosszú távú megbízhatóságát.
        </p>

        <div className="row">
          {services.map((service, index) => (
            <div
              className="col-md-4 mb-4"
              key={index}
              data-aos="fade-up"
              data-aos-delay={index * 150} // staggered animation
            >
              <div className="service-card">
                <img
                  src={service.image}
                  alt={service.title}
                  className="service-image"
                />
                <div className="service-info-row">
                  <div className="service-text">
                    <h5 className="service-title">{service.title}</h5>
                    <p className="service-desc">{service.description}</p>
                  </div>
                  <div className="service-btn-wrapper pb-4">
                    <a href="#contact" className="contact-btn">
                      Tovább
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
